/**
 * SympheniaLogo — kanonische Logo-Komponente
 *
 * Einzige Quelle für das Symphenia-Logo im ERP-Frontend.
 * Alle Seiten (Sidebar, Login, etc.) importieren diese Komponente.
 *
 * Props:
 *   size     — Höhe des SVG-Marks in px (default 20). Textgröße skaliert mit.
 *   context  — 'sidebar': Farben aus CSS-Sidebar-Variablen (theme-adaptiv)
 *              'content': Farben aus Tailwind design tokens (hsl(--foreground))
 */

interface SympheniaLogoProps {
  size?: number;
  context?: 'sidebar' | 'content';
  className?: string;
}

export function SympheniaLogo({
  size = 20,
  context = 'content',
  className,
}: SympheniaLogoProps) {
  const isSidebar = context === 'sidebar';

  // Farben je nach Kontext
  // Dot ist IMMER Steel Blue #0ea5e9 — feste Markenfarbe, nie vom Primary-Token abhängig
  const topPillFill = isSidebar ? 'var(--sidebar-fg)'  : 'hsl(var(--foreground))';
  const textColor   = isSidebar ? 'var(--sidebar-fg)'  : 'hsl(var(--foreground))';
  const dotColor    = '#0ea5e9'; // Steel Blue — konsistent auf allen Seiten und Themes

  // Textgröße proportional zur Mark-Höhe (Mark ≈ 20 → text-base 1rem)
  const fontSize = `${size}px`;

  return (
    <div
      className={`flex items-center${className ? ` ${className}` : ''}`}
      style={{ gap: '8px' }}
    >
      {/* Duoton Flow Mark */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        style={{ flexShrink: 0 }}
      >
        {/* Obere Pille: Sidebar-Farbe oder Foreground */}
        <rect x="10" y="3"  width="27" height="15" rx="7.5" fill={topPillFill} />
        {/* Untere Pille: immer Steel Blue */}
        <rect x="3"  y="22" width="27" height="15" rx="7.5" fill="#0ea5e9" />
      </svg>

      {/* Schriftzug: Symphenia + blauer Punkt direkt angehängt */}
      <span
        style={{
          color:         textColor,
          fontSize:      fontSize,
          fontWeight:    700,
          letterSpacing: '-0.02em',
          lineHeight:    1,
        }}
      >
        Symphenia
        <span style={{ color: dotColor }}>.</span>
      </span>
    </div>
  );
}
